import type { ProgramUserRsvp } from 'models';
import { Tag, Text } from 'ui';
import type { EventActionsView } from '../../types';
import { useGetPastEventStatusInformation } from './hooks';

type P = {
  status?: ProgramUserRsvp;
  view: EventActionsView;
};

const PastRsvpStatusTag = ({ status, view }: P) => {
  const getPastEventStatusInformation = useGetPastEventStatusInformation();
  const { icon, text } = getPastEventStatusInformation({ status });

  if (view === 'detail') {
    return null;
  }

  return (
    <Tag color="bg-none" icon={icon}>
      <Text>{text}</Text>
    </Tag>
  );
};

export default PastRsvpStatusTag;
